"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorNotification = void 0;
var _addToBasketFailed = require("@ori-events/add-to-basket-failed");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_TIMEOUT_DELAY = 3000;
const ErrorNotification = () => {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [message, setMessage] = (0, _react.useState)(undefined);
  const handleClose = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const handleShowErrorNotification = event => {
    const {
      localizedMessage
    } = event.detail;
    setMessage(localizedMessage);
    setIsOpen(true);
  };
  (0, _react.useEffect)(() => {
    window.addEventListener(_addToBasketFailed.Name, handleShowErrorNotification);
    return () => window.removeEventListener(_addToBasketFailed.Name, handleShowErrorNotification);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SnackbarError, {
    open: isOpen,
    message: message,
    autoHideDuration: DEFAULT_TIMEOUT_DELAY,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    onClose: handleClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Alert, {
      severity: "error",
      variant: "filled",
      children: message
    })
  }, "error");
};
exports.ErrorNotification = ErrorNotification;
